/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Stanard Report page
  Date: June 25, 2020
**/

import React, { useEffect, useState } from 'react';
import { Grid, /* Tooltip, IconButton */ } from '@material-ui/core';
import { /* EnhancedTable, */ SubmitSnackbar } from '../../components';
// import styles from './standardReport.module.scss';
import { useStoreState, useStoreActions } from 'easy-peasy';
// import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
// import ListIcon from '@material-ui/icons/List';
// import moment from 'moment';
import {
  globalAssoSearchListingTypeEntity,
  // globalDateEntity,
} from '../../constants/applicationConstants';
// import CustomInputFilter from '../../components/enhancedTable/filters/CustomInputFilter';
// import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
// import { Link } from 'react-router-dom';
import { stringConstants } from '../../constants/stringConstants';
import DisplayBreadcrumbs from '../../components/displayBreadcrumbs/displayBreadcrumbs';
import CustomListing from '../../components/customListing/CustomListing';
import FilterSection from '../../components/filterSections/FilterSection';
import StandardReportFilter from '../reportAdd/standardReportFilter';
import { sortByField } from '../../submodule';

const StandardReportPage = (props) => {
  const reportAction = useStoreActions((actions) => actions.report);
  const reportState = useStoreState((state) => state.report);
  const commonAction = useStoreActions((actions) => actions.common);
  // const skipPageReset = false;
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFlteredData] = useState({title: ''});
  const searchByKeyworld = (key, value) => {
    setFlteredData({ ...filteredData, [key]: value });
  };
  // const userInfo = useStoreState((state) => state.login.userInfo);
  const [currentRowPK, setCurrentRowPK] = useState(null);
  const [openApplyFilterForm, setOpenApplyFilterForm] = useState(false);

  function resetFilters() {
    setFlteredData({
      title: '',
    })
  }

  const downloadReport = (event, filePath) => {
    event.preventDefault();
    if (filePath) {
      reportAction
        .getPreSignedUrl({
          filename: filePath,
          operation_type: 'DOWNLOAD',
        })
        .then(function (response) {
          window.open(response.data.data.url);
        })
        .catch(function (error) {
          commonAction.setSubmitSnackbar({
            status: true,
            messages: stringConstants.fileDownloadFailureMsg,
            error: true,
          });
        });
    }
  };

  // load report list
  React.useEffect(() => {
    reportAction.getStandardReportList();
  }, []);

  /* const columns = [
    {
      Header: 'Title',
      accessor: 'title',
      sortType: 'caseInsensitive',
      procedureClass: true,
      Filter: CustomInputFilter,
    },
    {
      Header: 'Last Run',
      disableFilters: true,
      accessor: (c) => Date.parse(c.execution_datetime),
      Cell: ({ row }) => {
        let date;
        if (row.original.execution_datetime) {
          date = row.original.execution_datetime.replace(/-/g, '/');
          date = moment
            .utc(date)
            .local()
            .format(globalDateEntity.dateTimeFormatWith24Hour);
        }

        return <>{date}</>;
      },
      Filter: CustomInputFilter,
    },
    {
      Header: 'Action',
      Cell: ({ row }) => {
        const reporttype = 'standard';
        let date;
        if (row.original.execution_datetime) {
          date = row.original.execution_datetime.replace(/-/g, '/');
          date = moment
            .utc(date)
            .local()
            .format(globalDateEntity.dateTimeFormatWith24Hour);
        }
        return (
          <Grid>
            {row.original.query &&
            row.original.query.includes('_CONFIGURABLE') ? (
              <>
                <Tooltip title="Apply Filter & Execute Report">
                  <IconButton
                    color="primary"
                    aria-label="Apply Filter & Execute Report"
                    onClick={() => {
                      props.history.push(
                        `/standardreport/${encodeURIComponent(
                          row.original.PK,
                        )}`,
                      );
                    }}
                  >
                    <ListIcon />
                  </IconButton>
                </Tooltip>
              </>
            ) : (
              <Tooltip title="Execute Report">
                <IconButton
                  color="primary"
                  aria-label="Execute Report"
                  onClick={() => {
                    props.history.push(
                      `/reportresult/${reporttype}/${encodeURIComponent(
                        row.original.PK,
                      )}`,
                    );
                  }}
                >
                  <PlayCircleOutlineIcon />
                </IconButton>
              </Tooltip>
            )}
            {row.original.last_generated_report != null ? (
              <Link
                href="#"
                onClick={(event) =>
                  downloadReport(event, row.original.last_generated_report)
                }
              >
                <Tooltip title={date}>
                  <IconButton color="primary" aria-label={date}>
                    <CloudDownloadIcon />
                  </IconButton>
                </Tooltip>
              </Link>
            ) : (
              <IconButton
                color="primary"
                aria-label="Download Report"
                disabled="true"
                style={{ color: '#fff' }}
              >
                <CloudDownloadIcon />
              </IconButton>
            )}
          </Grid>
        );
      },
    },
  ]; */
  const filterList = [];
  useEffect(() => {
    let newTableData = [...reportState.standardReportList];
    newTableData = newTableData.filter((data) => {
      return (
        filteredData.title == '' ||
        data.title
          .toLocaleLowerCase()
          .match(filteredData.title.toLocaleLowerCase())
      );
    });
    newTableData = sortByField({
      data: newTableData,
      key: 'modify_date',
      secondKey: 'create_date',
    });
    setTableData(newTableData);
  }, [reportState.standardReportList, filteredData]);
  return (
    <Grid container direction="row" style={{ backgroundColor: '#fff' }}>
      <SubmitSnackbar />
      <Grid container direction="row">
        <Grid item md={12} xs={12}>
          <DisplayBreadcrumbs
            items={[
              { title: 'Reports', link: '' },
              { title: 'Standard Reports', link: '' },
            ]}
          />
        </Grid>
        <Grid item sm={12}>
          <Grid
            container
            style={{
              padding: '30px 20px 10px 20px',
              fontSize: 20,
              fontWeight: 600,
            }}
          >
            <Grid item md={4} style={{ display: 'flex' }}>
              Standard Reports &nbsp;&nbsp;
            </Grid>
            <FilterSection
              filterList={filterList}
              keywordsPlaceholder="Enter Title"
              keywordskey="title"
              keywordsValue={filteredData.title}
              handleKeywordsChange={searchByKeyworld}
              resetFilters={resetFilters}
            />
          </Grid>
        </Grid>

        {/* <Grid
          item
          md={12}
          className={styles.gridContainer}
          style={{ display: 'none' }}
        >
          <EnhancedTable
            columns={columns}
            data={reportState.standardReportList}
            rowSelection={false}
            skipPageReset={skipPageReset}
          />
        </Grid> */}
        <CustomListing
          tableData={tableData}
          entityType={globalAssoSearchListingTypeEntity.standard_report}
          handleInlineStatusChange={(event, entityData, clickType = null)=> {
            if(clickType === 'downloadReport') {
              downloadReport(event, entityData.last_generated_report);
            } else {
              setOpenApplyFilterForm(true);
              setCurrentRowPK(entityData.PK);
            }
          }}
          // setShowModal={setShowModal}
          // setChangeIndex={setChangeIndex}
          // setSelectedItems={setSelectedItems}
        />
      </Grid>
      {openApplyFilterForm && (
        <StandardReportFilter
          open={openApplyFilterForm}
          onCloseDialog={() => {
            setOpenApplyFilterForm(false);
          }}
          currentRowPK={currentRowPK}
        />
      )}
    </Grid>
  );
};

export default StandardReportPage;
